import { render, staticRenderFns } from "./BmFilterReorder.vue?vue&type=template&id=2a0d2d16&scoped=true&"
import script from "./BmFilterReorder.vue?vue&type=script&lang=js&"
export * from "./BmFilterReorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0d2d16",
  null
  
)

export default component.exports